export default () => ({
    isHidden: false,
    processingHide: false,
    processingDelete: false,
    showReasonModal: false,
    reason: '',
    deleteUrl: '',

    init() {
        // Initialize URLs and state
        this.isHidden = this.$el.dataset.hidden === 'true';
        this.toggleUrl = this.$el.dataset.toggleUrl;
        this.deleteUrl = this.$el.dataset.deleteUrl;
        
        // Set initial checkbox state
        if (this.$refs.hideToggle) {
            this.$refs.hideToggle.checked = this.isHidden;
        }
    },

    openReasonModal() {
        this.showReasonModal = true;
        this.reason = '';
    },

    closeReasonModal() {
        this.showReasonModal = false;
        this.reason = '';
    },

    async deleteReview() {
        if (this.processingDelete) return;
        this.processingDelete = true;

        try {
            const response = await fetch(this.deleteUrl, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            
            // Show success message
            window.dispatchEvent(new CustomEvent('show-toast', {
                detail: {
                    type: 'success',
                    message: data.message,
                }
            }));

            // Remove the review card from DOM or reload page
            const reviewCard = this.$el.closest('.review-card');
            if (reviewCard) {
                reviewCard.remove();
            } else {
                window.location.reload();
            }

        } catch (error) {
            console.error('Error deleting review:', error);
            window.dispatchEvent(new CustomEvent('show-toast', {
                detail: {
                    type: 'error',
                    message: 'Failed to delete review. Please try again.',
                }
            }));
        } finally {
            this.processingDelete = false;
            
            // Safely handle modal closure
            const modal = this.$el.closest('.modal');
            if (modal && typeof modal.close === 'function') {
                modal.close();
            }
        }
    },

    async toggleReviewVisibility() {
        if (this.processingHide) return;
        this.processingHide = true;

        try {
            const response = await fetch(this.toggleUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    is_hidden: !this.isHidden,
                }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            this.isHidden = data.hidden;

            // Show toast notification
            window.dispatchEvent(new CustomEvent('show-toast', {
                detail: {
                    type: 'success',
                    message: data.message,
                }
            }));

            // No page reload needed since we're managing state locally
        } catch (error) {
            console.error('Error toggling review visibility:', error);
            window.dispatchEvent(new CustomEvent('show-toast', {
                detail: {
                    type: 'error',
                    message: 'Failed to update review visibility. Please try again.',
                }
            }));
        } finally {
            this.processingHide = false;
        }
    }
});
